import { createSlice } from '@reduxjs/toolkit'

export const tokensSlice = createSlice({
    name: 'tokens',
    initialState: {
        user: [],
        headers: []
    },
    reducers: {
        setUser: (state, action) => {
            state.user = action.payload
        },
        setHeaders: (state, action) => {
            state.headers = action.payload
        }
    }
})

export const { setUser } = tokensSlice.actions
export const { setHeaders } = tokensSlice.actions

export default tokensSlice.reducer